import React, { useEffect, useState } from "react";
import "../App.css";

import HeroSection from "../components/HeroSection";

// import Blog from './Blog';
import Card from "./Card/Card";
import { Service } from "./Service";
// import { Signup } from './Signup';
import Counter from "./Counter";
import { Contact } from "./Contact/Contact";
import { Banner } from "./Banner/Banner";
// import { Mentors } from "./Mentor/Mentors";
import UpcomingEvent from "./Events/UpcomingEvent";
import BannerText from "./BannerText/BannerText";
import { Testimonial } from "./Testimonial/Testimonial";
import OfferCard from "./OfferCard";
import { Navigate, useLocation } from "react-router-dom";
import SlideComponent from "./React/Toast/SlideComponent";

function Home() {
    const location = useLocation();
    const propData = location.state ? location.state.data : null;
    console.log(propData, "props data")
    debugger
	const [showAlert, setShowAlert] = useState();
	const [message, setMessage] = useState({
        messageType: "",
        message: "",
    });

	useEffect(() => {
		if (propData) {
            setShowAlert(true);
            setMessage({
                ...message,
                messageType: propData.messageType,
                message: propData.message,
            });
            Navigate({state: {}})
            // history.replace({ state: {} }); // clear the state as refreshing and reloading page will not clear the state resulting the message appear again
        }
	},[])
	return (
		<>
			<HeroSection />
			<Banner />
			{/* <BannerText /> */}
			{/* <Signup/> */}
			<Counter />
			<Service />
			<Card />
			<UpcomingEvent />
			{/* <Mentors /> */}
			<Testimonial />
			<OfferCard/>
			<Contact />
			{showAlert && (
                <SlideComponent
                    transition="left"
                    show={showAlert}
                    handleClose={() => {
                        setShowAlert(false);
                    }}
                    messageType={message.messageType}
                    message={message.message}
                />
            )}
		</>
	);
}

export default Home;
